import React from "react";
import { BiSearchAlt } from "react-icons/bi";

const FormSearch = () => {
  return (
    <>
      <div className="h-auto p-4 flex justify-center items-center shadow-sm mt-4">
        <BiSearchAlt size={25} className="mr-2" />
        <input
          type="text"
          className="w-full h-full w-full border-0 outline-none text-sm text-dark pr-2 font-regular focus:border-transparent focus:ring-0"
          placeholder="Search..."
        />
      </div>
    </>
  );
};

export default FormSearch;
